module.exports = __webpack_public_path__ + "img/bg.3a51c985.webp";